import React from 'react';
/**
 * Mobile device frame for presenting screen wireframes in a desktop preview.
 * Approximates an iPhone 14/15 aspect ratio (~390 x 844).
 */
export function DeviceFrame({
  children,
  label
}: {
  children: React.ReactNode;
  label?: string;
}) {
  return <div className="flex flex-col items-center gap-3" data-id="element-330">
      {label && <div className="text-[12px] uppercase tracking-[0.08em] font-semibold text-neutral-500" data-id="element-331">
          {label}
        </div>}
      <div className="relative bg-black rounded-[44px] p-[10px] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.35)]" style={{
      width: 390,
      height: 844
    }} data-id="element-332">
        <div className="relative w-full h-full rounded-[36px] overflow-hidden bg-white" data-id="element-333">
          {/* Notch */}
          <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 w-[110px] h-[28px] bg-black rounded-full" data-id="element-334" />
          {children}
        </div>
      </div>
    </div>;
}